import { prettyCompetitionName } from "./competitionNames";

const LEAGUE_CODE_TO_ID = {
  EPL: 39,
  CHAMP: 40,
  LIGUE1: 61,
  BUNDES: 78,
  LA_LIGA: 140,
  SERIE_A: 135,
  SCO_PREM: 179,
  ARG_PN: 129,
  ARG_PB_METRO: 131,
  COPA_AMERICA: 9,
  UCL: 2,
  UEL: 3,
  UECL: 848,
  WC: 1,
};

const LEAGUE_CODE_TO_NAME = {
  EPL: "Premier League",
  CHAMP: "EFL Championship",
  LIGUE1: "Ligue 1",
  BUNDES: "Bundesliga",
  LA_LIGA: "La Liga",
  SERIE_A: "Serie A",
  SCO_PREM: "Scottish Premiership",
  SCO_CHAMP: "Scottish Championship",
  ARG_LP: "Argentina Liga Profesional",
  ARG_PN: "Primera Nacional",
  ARG_PB_METRO: "Primera B Metropolitana",
  ARG_CDL: "Copa de la Liga Profesional",
  ARG_CUP: "Copa Argentina",
  COPA_AMERICA: "Copa America",
  MEX_LIGA_MX: "Liga MX",
  MEX_LIGA: "Liga MX",
  TUR_SUPER: "Turkish Super Lig",
  TUR_SUPER_LIG: "Turkish Super Lig",
  POL_EKS: "Ekstraklasa",
  POL_EKSTRAKLASA: "Ekstraklasa",
  CZE_FIRST: "Czech First League",
  CZE_1_LIGA: "Czech First League",
  SUI_SUPER: "Swiss Super League",
  SUI_SUPER_LEAGUE: "Swiss Super League",
  UCL: "UEFA Champions League",
  UEL: "UEFA Europa League",
  UECL: "UEFA Conference League",
  WC: "FIFA World Cup",
};

const LEAGUE_NAME_TO_CODE = {
  "PREMIER LEAGUE": "EPL",
  "EFL CHAMPIONSHIP": "CHAMP",
  "LIGUE 1": "LIGUE1",
  BUNDESLIGA: "BUNDES",
  "LA LIGA": "LA_LIGA",
  "SERIE A": "SERIE_A",
  "SCOTTISH PREMIERSHIP": "SCO_PREM",
  "PRIMERA NACIONAL": "ARG_PN",
  "PRIMERA B METROPOLITANA": "ARG_PB_METRO",
  "COPA AMERICA": "COPA_AMERICA",
  "UEFA CHAMPIONS LEAGUE": "UCL",
  "UEFA EUROPA LEAGUE": "UEL",
  "UEFA CONFERENCE LEAGUE": "UECL",
  "UEFA EUROPA CONFERENCE LEAGUE": "UECL",
  "FIFA WORLD CUP": "WC",
  "WORLD CUP": "WC",
};

const normalizeRawLeagueKey = (value = "") =>
  String(value)
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

const toLeagueCode = (value) => {
  const raw = normalizeRawLeagueKey(value);
  if (!raw) return null;
  if (LEAGUE_CODE_TO_NAME[raw]) return raw;
  if (LEAGUE_NAME_TO_CODE[String(value).trim().toUpperCase()]) {
    return LEAGUE_NAME_TO_CODE[String(value).trim().toUpperCase()];
  }
  if (/^[A-Z0-9_]+$/.test(raw) && raw.length >= 3) {
    return raw;
  }
  return null;
};

export const getLeagueCodeFromAny = ({ code, name, id } = {}) => {
  const codeFromCode = toLeagueCode(code);
  if (codeFromCode) return codeFromCode;

  const codeFromName = toLeagueCode(name);
  if (codeFromName) return codeFromName;

  if (id !== undefined && id !== null) {
    const numericId = Number(id);
    if (Number.isFinite(numericId)) {
      const byId = Object.entries(LEAGUE_CODE_TO_ID).find(([, leagueId]) => leagueId === numericId);
      if (byId) return byId[0];
    }
  }

  return null;
};

export const getLeagueNameFromAny = ({ code, name, id } = {}) => {
  const resolvedCode = getLeagueCodeFromAny({ code, name, id });
  if (resolvedCode) {
    return LEAGUE_CODE_TO_NAME[resolvedCode] || prettyCompetitionName(resolvedCode, resolvedCode);
  }
  const raw = name || code || null;
  if (!raw) return null;
  return prettyCompetitionName(raw, raw);
};

export const getLeagueIdFromAny = ({ code, id } = {}) => {
  if (id !== undefined && id !== null) {
    const numericId = Number(id);
    if (Number.isFinite(numericId)) return numericId;
  }
  const resolvedCode = getLeagueCodeFromAny({ code });
  return resolvedCode ? LEAGUE_CODE_TO_ID[resolvedCode] : null;
};
